import { render, staticRenderFns } from "./MetaTag.vue?vue&type=template&id=796e4948&"
import script from "./MetaTag.vue?vue&type=script&lang=js&"
export * from "./MetaTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports